module.exports = __webpack_public_path__ + "static/media/tracker.c9f58ba6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/tracker.svg
// module id = 237
// module chunks = 7